import React from 'react';

/**
 * Custom icon for "Plan Management" (unique SVG, not from an icon library).
 * Uses currentColor so it inherits the sidebar text color.
 */
export const PlanManagementIcon = ({ className, ...props }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      {/* Blueprint sheet */}
      <path
        d="M7 3.5h7.5L18.5 7.5V20a1.5 1.5 0 0 1-1.5 1.5H7A1.5 1.5 0 0 1 5.5 20V5A1.5 1.5 0 0 1 7 3.5Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      {/* Folded corner */}
      <path
        d="M14.5 3.5V7a.5.5 0 0 0 .5.5h3.5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      {/* Plan nodes + connection */}
      <path
        d="M8 12h8"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M9 12a1 1 0 1 1-2 0a1 1 0 0 1 2 0Z"
        fill="currentColor"
      />
      <path
        d="M17 12a1 1 0 1 1-2 0a1 1 0 0 1 2 0Z"
        fill="currentColor"
      />
      {/* Check mark (management/approval) */}
      <path
        d="M8.2 16.2l1.7 1.7 3.9-3.9"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};


